import React from 'react';
import PropTypes from 'prop-types';
import ShowComponent from '../hocs/ShowComponent';

@ShowComponent
class ErrorAlertComponent extends React.Component {
  render() {
    const {
      responseError,
      errorFields,
    } = this.props;

    let errorFieldMessages;
    if (errorFields.length > 0) {
      errorFieldMessages = errorFields.map((field, index) => {
        let errorMessage = <div key={field}>- {field};</div>;
        if (index === errorFields.length - 1) {
          errorMessage = <div key={field}>- {field}.</div>;
        }

        return errorMessage;
      });
    }

    const responseErrorAlert = responseError ?
      <div className="alert-danger columns">{responseError}{errorFieldMessages}</div> : null;
    return (
      <div>
        {responseErrorAlert}
      </div>
    );
  }
}

ErrorAlertComponent.propTypes = {
  responseError: PropTypes.string,
  errorFields: PropTypes.arrayOf(PropTypes.shape({})),
};

ErrorAlertComponent.defaultProps = {
  responseError: '',
  errorFields: [],
};

export default ErrorAlertComponent;
